import React from 'react';
import { connect } from 'react-redux';
import { Impression } from '@nerdwallet/analytics/react/impression';
import lazy, { Hydrate } from '../../../lazy/lazy-universal';

import type { LoanTerm } from '../../../amortization-calculator/types';
import { MORTGAGE_ANALYTICS_HASH } from '../analytics-constants';
import type { MortgageCalculators } from '../types';

// Lazy Load Component
const MonthlyResults = lazy(
  () =>
    import(
      /* webpackChunkName: 'lazy-monthly-results' */ '../../../currency/monthly-results/monthly-results'
    ),
  { hydrate: Hydrate.WHEN_VISIBLE }
);

interface MCMonthlyResultsProps {
  mortgageCalculator: MortgageCalculators;
}

interface StateProps {
  /** derived from redux */
  loanTerm?: LoanTerm;
  /** derived from redux */
  monthlyPaymentsTotal?: number;
}

type OwnProps = MCMonthlyResultsProps & StateProps;

const MCMonthlyResults = ({
  monthlyPaymentsTotal,
  loanTerm,
  mortgageCalculator,
}: OwnProps): JSX.Element => {
  const ANALYTICS =
    MORTGAGE_ANALYTICS_HASH[mortgageCalculator].RESULTS_HEADER_FORM;

  return (
    <Impression
      eventType={ANALYTICS.EVENT_TYPE}
      entityName={ANALYTICS.ENTITY_NAME}
      payload={{
        form_name: ANALYTICS.FORM_NAME,
        section_name: ANALYTICS.SECTION_NAME,
      }}
    >
      <MonthlyResults
        headerText="Your monthly payment"
        loanTerm={loanTerm}
        total={monthlyPaymentsTotal}
      />
    </Impression>
  );
};

const mapStateToProps = (state) => {
  const reducer = state?.mortgageCalculator;

  return {
    loanTerm: reducer?.inputs?.loanTerm,
    monthlyPaymentsTotal: reducer?.outputs?.monthlyPayments?.total,
  };
};

export default connect<
  StateProps,
  Record<string, never>,
  MCMonthlyResultsProps
>(mapStateToProps)(MCMonthlyResults);
